import { ComponentType } from "react";

export default function CustomErrorMessage({ children }: { children?: any }) {
  return (
    <span className="d-block texts mt-2">{children}</span>
  );
}
